import React from 'react';
import PropTypes from 'prop-types';

import {
  BlackComponent,
  Loader,
} from './styles';

const HangTight = (props) => {
  const {
    processingError,
    errorMessage,
    hangTightMessage,
  } = props;
  return (
    <BlackComponent>
      {processingError
        ? errorMessage : (
          <>
            {hangTightMessage}
            <Loader data-loader="hang-loader" />
          </>
        )}
    </BlackComponent>
  );
};

HangTight.propTypes = {
  processingError: PropTypes.bool,
  errorMessage: PropTypes.string,
  hangTightMessage: PropTypes.string,
};

HangTight.defaultProps = {
  errorMessage: null,
  hangTightMessage: null,
  processingError: false,
};

export default HangTight;
